
import * as EmailValidator from "email-validator";

import {isEmpty, MAX_ALLOWED_LENGTH} from "../utils/commons";
import * as apis from "../apis/contact_apis";


export const CONTACT_ON_CHANGE = "contactOnChange";
export const CONTACT_ON_VALIDATE = "contactOnValidate";
const CONTACT_SUBMITTING = "contactSubmitting";
const CONTACT_SUBMITTED = "contactSubmitted";
const RESET_CONTACT = "resetContact";

const initContactErrors = () => ({
    email: "",
    names: "",
    subject: "",
    details: "",
})

const subjectsOptions = () => {

    return ["General enquiry",
            "Complain",
            "Suggestion",
            "Aspiring developer",
            "More ideas"
            ]
}

const initState = () => ({
        email: "",
        names: "",
        subject: "",
        details: "",
        error: "",
        info: "",
        submitting: false,
        subjectOptions: subjectsOptions(),
        fieldErrors: initContactErrors(),
})

const state = initState();

const mutations = {
    [CONTACT_ON_CHANGE] (state, payload) {
        Object.assign(state, {[payload.name]:payload.value});
    },
    [CONTACT_ON_VALIDATE] (state, payload) {
        Object.assign(state, {fieldErrors: {...payload}});
    },
    [CONTACT_SUBMITTING] (state) {
        Object.assign(state, {submitting: true, error: "", info: ""});
    },
    [CONTACT_SUBMITTED] (state, payload) {
        Object.assign(state, {submitting: false, error: payload.error, info: payload.info});
    },
    [RESET_CONTACT] (state) {
        Object.assign(state, initState());
    }
}

const actions = {
    [CONTACT_ON_CHANGE] ({commit}, payload) {
        commit(CONTACT_ON_CHANGE, payload)
    },
    [RESET_CONTACT] ({commit}, payload) {
        commit(RESET_CONTACT, payload)
    },
    [CONTACT_ON_VALIDATE] ({commit, state, rootState}) {
        let errors = {};

        let fieldsToValidate = ["email", "names", "subject", "details"];
        //if logged in will get email and names from context
        if(rootState.globalStore.user.email) {
            fieldsToValidate = ["subject", "details"];
        }
        fieldsToValidate.forEach( key => {

            if(isEmpty(state[key])) {
                errors[key] = "This field is required";
            }

        });

        if(!rootState.globalStore.user.email && state.email) {
            if(!EmailValidator.validate(state.email)) {
                errors["email"] = "Email is invalid";
            }
        }
        if(state.details) {
            if(state.details.length > MAX_ALLOWED_LENGTH || state.details.length < 20) {
                errors["details"] = "Details field is invalid";
            }
        }

        commit(CONTACT_ON_VALIDATE, errors);
        if(Object.keys(errors).length > 0) {
            commit(CONTACT_ON_CHANGE, {name: "error", value: "Some fields invalid"});
        }else {
            commit(CONTACT_ON_CHANGE, {name: "error", value: ""});
        }
    },
    submitContact ({commit, state}) {

        commit(CONTACT_SUBMITTING);
        apis.submitContact({email: state.email, names: state.names,
                                subject: state.subject, details: state.details})
            .then((results) => {
                    let payload = results || {};
                    payload.info = "Query submitted, and confirmation email sent.";
                    commit(CONTACT_SUBMITTED, payload);
                },
                (results) => {
                    let error = !results.error? "Failed to submit.": results.error;
                    commit(CONTACT_SUBMITTED, {info: "", "error": error});
                })
    }
}


export default {
    state,
    mutations,
    actions
}
